import {captureException} from "@sentry/react";

export default function toCapitalize(text) {
    if (typeof text !== 'string') return text;

    try {
        return text.charAt(0).toUpperCase() + text.slice(1);
    } catch (error) {
        captureException(error, {
            extra: {
                text
            }
        })
        return text;
    }
}
